import { useMutation, useQueryClient } from 'react-query';

import type { IStandardErrorResponse } from 'src/api/common';
import { useNotifications } from 'src/notifications';
import { apiClient } from 'src/services/api/client';
import { queryKeys } from 'src/services/api/constants';
import type { IIntegration } from 'src/services/api/integrations/types';

const PATH = 'api/landlord/facebook-integration';

type UsernamePasswordRequest = {
  username: string;
  password: string;
}

export type FacebookCookie = {
    datr: string;
    c_user: string;
    xs: string;
    sb: string;
}

type CookieRequest = {
    cookie: FacebookCookie;
}

export const useConnectFacebook = () => {
    const queryClient = useQueryClient();
    const { addNotification } = useNotifications();

    return useMutation<IIntegration, IStandardErrorResponse, UsernamePasswordRequest | CookieRequest>(
        async (payload: UsernamePasswordRequest | CookieRequest) => {
            const json = Object.assign({}, payload);
            return apiClient(PATH, { method: 'post', json }).json<IIntegration>();
        }, {
            onSuccess: () => {
                queryClient.invalidateQueries(queryKeys.facebookIntegration);
                addNotification('Facebook account connected successfully', 'success');
            },
            onError: (error) => {
                const errorMessage = error.msg || 'Failed to connect Facebook account';
                addNotification(errorMessage, 'error');
            }
        }
    );
};
